import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { UntilDestroy } from '@ngneat/until-destroy';
import { SubscriptionFacadeService } from '../../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@UntilDestroy()
@Component({
    selector: 'company-situation-comptable-form',
    templateUrl: './company-situation-comptable-form.component.html',
    styleUrls: ['./company-situation-comptable-form.component.scss'],
    standalone: false
})
export class CompanySituationComptableFormComponent
  extends EaSubscriptionBuilder
  implements OnInit, AfterViewInit
{
  @Input() col: number = 6;

  constructor(
    protected formConstructor: PrFormConstructor,
    private cd: ChangeDetectorRef,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
    // new add
  }
  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
